/**
 * The status of risk limits for a party.
 * tag: 2355
 * @readonly
 * @enum {number} (int)
 */
export enum PartyRiskLimitStatus {
  Disabled = 0,
  Enabled = 1,
}
